import { AgencyFragment } from '@gql'
import { useStoreState } from '@store/hooks'

export default function useCurrentAgency(): AgencyFragment | undefined {
  return useStoreState((state) => state.agency.current)
}
